import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import SFNavbar from './SFComponents/SFNavbar/SFNavbar';
import ContentPanel from '../components/ContentPanel';
import SFAuth from './SFPages/SFAuth/SFAuth';
import { AppProperties } from '../common/functions';
import ESComponentWrapper from '../components/ESComponentWrapper';
import { NotificationContainer } from 'react-notifications';
import SFAnonymousPage from './SFPages/SFAnonymousPage';

class SFApp extends Component {

  appProperties = AppProperties();

  render() {

    console.debug("this.appProperties.currentUserData", this.appProperties.currentUserData)

    if ((location && location.pathname && location.pathname.includes('/anonymous'))) {
      return <SFAnonymousPage history={this.props.history}></SFAnonymousPage>
    }

    // check if query params has token if so go to SFAuth
    let hasToken = false;
    const queryParams = new URLSearchParams(window.location.search);
    if (queryParams) {
      let token = queryParams.get('token');
      if (token !== undefined && token !== null) {
        hasToken = true;
      }
    }
    if (this.appProperties.currentUserData.hasValidData() !== true || hasToken) {

      let LoginPage = ESComponentWrapper(SFAuth);

      return <LoginPage {...this.props} />
    }

    return (
      <div className='h-100'
        style={{
          background: '#f6f7f8',
          maxWidth: '1920px',
          margin: '0 auto',
        }} >
        {this.appProperties.currentUserData.isAnonymous ? 
          null :
          <SFNavbar {...this.props} />
        }
        <ContentPanel history={this.props.history} className="m-0 p-0 h-100" />
        <NotificationContainer />
      </div>
    )
  }
}


export default withRouter(SFApp);